$(function(){
  var scroll = window.requestAnimationFrame ||
      // IE Fallback
  function(callback){ window.setTimeout(callback, 1000/30)};
  var elementsToShow = document.querySelectorAll('.content .shopify-section');
  var elementsToZoom = document.querySelectorAll('.number-of-blocks .table-center .tab-body'); 
  // $(elementsToShow).classList.remove('fadeInDown');
  function loop(){
	var wd = $(window).width();
    Array.prototype.forEach.call(elementsToShow, function(element){
      if (isElementInViewport(element)) {
        //         element.classList.add('fadeIn');
        var clsList = element.firstElementChild.classList;
        if(wd > 767){
        if(clsList.contains('number-of-blocks')){
			$('.number-of-blocks .table-center .tab-body').each(function(p){
                            var elementCls = $(this).attr('class');
//               var elementCls = $(this);
              window.setTimeout(function(){ 
          Array.prototype.forEach.call(elementsToZoom, function(element2){
            if (isElementInViewport(element2)) {
//                element2.style('opacity', '1');
//                element2.style('animation', '0.5s fade-in 0s both linear');
//               console.log(elementCls);
              if(element2.classList == elementCls){
              element2.classList.add('fade-section','opacity-1');
              var i = 1;
              var j = 2;
              var timeout = 600+i;
              $('.tab-body.fade-section').each(function(){

                var block = $(this).find('.brands .hvrbox-zoom:nth-child('+i+')');
//                 block.css('animation',j+'s fade-in 0s both linear');
// 					block.css('-webkit-animation',j+'s fade-in 0s both linear');
                  block.addClass('fade-in');
                  block.css('opacity','1');
//                   console.log(block+' '+timeout);
                j+=3;
                i = i++;
//                 i = i+300;
              });
              }
            } 
          });
                }, 2000);
            });

        }
        }
        if(clsList.contains('home-image-with-text-overlay')){

          $('.home-image-with-text-overlay').find('.background-overlay').addClass('fadeInLeft');
        }
        if(clsList.contains('slider-processbar-wrapper')){
          $('.slider-processbar-wrapper').find('li .highlight-bar').addClass('slideInDown');
          $('.slider-processbar-wrapper').find('li.actslide .highlight-bar').addClass('slideInDown');
        }
        //         console.log(element.firstElementChild.classList);
      } 
      //       else {
      //         element.classList.remove('fadeInDown');
      //         element.firstElementChild.classList.remove('slide-left');
      //       }
    });

    scroll(loop);
  }

  // Call the loop for the first time
   loop();

  // Helper function from: http://stackoverflow.com/a/7557433/274826
  function isElementInViewport(el) {
    // special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
      el = el[0];
    }
    var rect = el.getBoundingClientRect();
    return (
      (rect.top <= 0
       && rect.bottom >= 0)
      ||
      (rect.bottom >= (window.innerHeight || document.documentElement.clientHeight) &&
       rect.top <= (window.innerHeight || document.documentElement.clientHeight))
      ||
      (rect.top >= 0 &&
       rect.bottom <= (window.innerHeight || document.documentElement.clientHeight))
    );
  }
  function isElementPartiallyInViewport(el)
  {
    //special bonus for those using jQuery
    if (typeof jQuery !== 'undefined' && el instanceof jQuery) el = el[0];

    var rect1 = el.getBoundingClientRect();
    // DOMRect { x: 8, y: 8, width: 100, height: 100, top: 8, right: 108, bottom: 108, left: 8 }
    var windowHeight = (window.innerHeight || document.documentElement.clientHeight);
    var windowWidth = (window.innerWidth || document.documentElement.clientWidth);

    // http://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
    var vertInView = (rect1.top <= windowHeight) && ((rect1.top + rect1.height) >= 50);
    var horInView = (rect1.left <= windowWidth) && ((rect1.left + rect1.width) >= 0);

    return (vertInView && horInView);
  }


  jQuery("#js-rotating").Morphist({
    animateIn: 'slideInRight',
    animateOut: 'slideOutLeft'
  });
});